import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * Fires a lightweight visit ping on every route change.
 * Skips staff / admin users (they should not inflate visitor stats).
 * Backend also enforces the staff-skip server-side.
 */
export default function useVisitTracker() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (loading) return; // wait until auth resolved
    if (user?.role === "staff" || user?.role === "admin") return;
    const path = location.pathname + (location.search || "");
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    api.post("/track/visit", {
      path,
      referrer: document.referrer || null,
    }).catch(() => {
      /* silent — tracker must never break UX */
    });
  }, [location.pathname, location.search, user, loading]);
}
